<template>
  <q-layout view="lhh LpR lff">
    <q-page-container>
      <q-page padding class='full-width'>
          <div class="row justify-between">
          <q-btn class="justify-center q-ma-xs q-pr-md" ripple dense flat color="black" to="/">
            <q-icon name='arrow_left' style="font-size:2.5em"></q-icon> Quay lại
          </q-btn>
        </div>
        <div class='row d-flex '>
        <div v-for="(item,index) in menu" :key="index" class='col-12 col-sm-4 col-md-3 q-pa-md'>
          <q-btn class='full-width my-card relative-position' :style="'margin: 0 auto;overflow:hidden; min-height:150px;color:white;background:'+colors[index]" :to='item.ref'>
            <q-card-section class='full-width'>
              <div class='text-h5 text-right'>{{item.name}}
              </div>
            </q-card-section>
            <q-card-section class='text-left absolute q-my-xl' style='left:-8%;top:20%'>
              <q-icon :name='item.icon' style='font-size: 7em; opacity:0.3' />
            </q-card-section>
          </q-btn>
        </div>
        </div>
      </q-page>
    </q-page-container>
  </q-layout>
</template>

<script>
export default {
  data() {
    return {
      menu: [
        { ref: '/statistics/plan', name: 'Kế hoạch', icon: 'assignment'},
        { ref: '/statistics/daily', name: 'Hàng ngày', icon: 'assignment'},
        { ref: '/statistics/labor', name: 'Nhân công', icon: 'person'},
      ],
      colors: ['#00a152', '#f44336', '#2196f3', '#9c27b0', '#795548', '#f48fb1'],
    }
  }
}
</script>

<style scoped>
.wrap {
  max-width: 1200px;
  text-align: center;
  margin: auto;
}
#video {
  width:100%;
  max-width: 640px;
}
</style>
